<template>
  <div class="order-Info">
    <div class="message">
      <span class="info-title">订单类型</span>
      <span class="info-value">{{ order.tradeType | convertStatus }} </span>
    </div>
    <div class="message">
      <span class="info-title">订单编号</span>
      <span class="info-value"> {{ order.orderNo }} </span>
    </div>
    <div class="message">
      <span class="info-title">订单生成时间</span>
      <span class="info-value">{{ order.createTime }}</span>
    </div>
    <div class="message-title" style="font-weight: bold;">
      卖家信息
    </div>
    <div class="message">
      <span class="info-title">公司名称</span>
      <span class="info-value">{{ order.sellerEnterpriseName }}</span>
    </div>
    <div class="message">
      <span class="info-title">联 系 人</span>
      <span class="info-value">{{ order.sellerEnterpriseName }}</span>
    </div>
    <div class="message">
      <span class="info-title">联系电话</span>
      <span class="info-value">{{ order.sellerContactTel }}</span>
    </div>
    <div class="message-title" style="font-weight: bold;">
      买家信息
    </div>
    <div class="message">
      <span class="info-title">公司名称</span>
      <span class="info-value">{{order.buyerEnterpriseName}}</span>
    </div>
    <div class="message">
      <span class="info-title">联 系 人</span>
      <span class="info-value">{{order.auditUserName}}</span>
    </div>
    <div class="message">
      <span class="info-title">联系电话</span>
      <span class="info-value">{{order.buyerContactTel}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderInfoCardDetail",
  props: {
    order: Object,
  },
  data() {
    return {};
  },
  filters: {
    convertStatus: function (value) {
      switch (value) {
        case "JH":
          return "计划";
        case "JJ":
          return "竞拍";
        case "PD":
          return "拼单";
        case "SG":
          return "闪购";
        case "CH":
          return "现货";
      }
    },
  },
  computed: {
   
  },
};
</script>
<style lang="stylus" scoped>
.order-Info {
  overflow: hidden;
  background-color: #fff;
  margin: 32px 0;
  padding: 0 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;

  .message {
    margin: 40px 0;
    line-height: 33px;

    .info-title {
      margin-right: 48px;
      color: #666666;
    }

    .info-value {
      color: #333;
    }
  }

  .message-title {
    margin-top: 48px;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }
}
</style>
